// extracted by mini-css-extract-plugin
export default {"visuallyHidden":"seoVisuallyHidden_visuallyHidden__ymC8c"};